import request from '@/utils/request'

// 获取我的小区列表
export function listMyCommunity(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/enterCommunity/listMyCommunity',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取未入驻小区列表
export function listNoEnterCommunity(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeEnterCommunity/listNoEnterCommunity',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 申请入驻小区
export function saveEnterCommunity(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeEnterCommunity/_saveEnterCommunity',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 退出小区
export function exitCommunity(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeExitCommunity/exit',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 修改小区面积
export function updateCommunityArea(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/editCommunity/update',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}